import {
  Type,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  OnInit,
  ViewContainerRef, Output, EventEmitter,
} from '@angular/core';
import {QuestionInput} from './question-input';
import {QuestionInfo} from '../model/question.model';
import {equals} from '../util';
import {QuestionType} from '../model/question-type';
import {DateComponent} from './date/date.component';
import {InputComponent} from './input/input.component';
import {InputNumberComponent} from './input-number/input-number.component';
import {RadioGroupComponent} from './radio-group/radio-group.component';
import {SelectComponent} from './select/select.component';
import {DateRangeComponent} from './date-range/date-range.component';
import {FIELD_TYPES} from "../config/fieldTypes.config";
import {TextareaComponent} from "./textarea/textarea.component";
import {YearMonthDateComponent} from "./year-month-date/year-month-date.component";



@Directive({
  selector: '[appInput]'
})
export class InputDirective extends QuestionInput implements OnInit {
  private _question;

  @Output() submitted = new EventEmitter();

  @Input()
  public set question(value: QuestionInfo) {

    if (value && !equals(this._question, value)) {
      this._question = value;

        this.buildInput();

    }
  }

  inputComponentRef: ComponentRef<QuestionInput>;

  constructor(private r: ComponentFactoryResolver, private container: ViewContainerRef) {
    super();

  }

  get answer(): any {
    return this.inputComponentRef.instance.answer;
  }

  ngOnInit(): void {
    document.addEventListener('keydown', e => {
      if (e.code === 'Enter') {
        const answerLength = this.inputComponentRef.instance.question.answerLength;

        // if ((answerLength && (this.inputComponentRef.instance as any).inputField.value === answerLength) || !answerLength) {
          this.submitted.emit();
        // }
      }
    })
  }

  buildInput() {
    const currentQuestion = this._question;
    if (this.container && currentQuestion) {
      this.container.clear();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore

      let type = <Type<any>>this.getInputType(currentQuestion.fieldType);
      const factory = this.r.resolveComponentFactory(type);

      this.inputComponentRef = this.container.createComponent(factory);
      this.inputComponentRef.instance.question = this._question;

      let subsc = this.inputComponentRef.instance.questionAnswered.subscribe(answer => {
        this.questionAnswered.emit(answer);
      });

      this.inputComponentRef.onDestroy(() => {
        this.inputComponentRef = null;
        subsc.unsubscribe();
        subsc = null;
      });
    }
  }


  private getInputType(questionType) {

    switch (questionType) {
      case QuestionType.DATE.toLocaleString():
        return DateComponent;
      case QuestionType.DATE_RANGE:
        return DateRangeComponent;
      case QuestionType.INPUT_TEXT.toLocaleString():
      case FIELD_TYPES.text:
      case FIELD_TYPES.textList:
          return InputComponent;
      case QuestionType.INPUT_NUMBER.toLocaleString():
      case QuestionType.INPUT_PHONE.toLocaleString():
      case FIELD_TYPES.dollar:
        return InputNumberComponent;
      case QuestionType.RADIO_GROUP.toLocaleString():
        return RadioGroupComponent;
      case QuestionType.CHECK_GROUP.toLocaleString():
      case QuestionType.SELECT.toLocaleString():
        return SelectComponent;
      case FIELD_TYPES.textarea:
        return TextareaComponent;
      case FIELD_TYPES.yearDate:
        return YearMonthDateComponent;

      case FIELD_TYPES.textListTwo:
        return InputComponent;
    }
  }
}
